import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  ListItem, ListItemText, ListItemButton, Badge,
} from '@mui/material';

export default function HeaderMenuItem(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    url, menuName, onClose, badgeCount,
  } = props;

  const onClick = (_, link) => {
    onClose();
    navigate(link);
  };

  const path = `/${location.pathname.split('/')[1]}`;

  return (
    <ListItem
      sx={{ padding: 0 }}
      onClick={(event) => onClick(event, url)}
    >
      <ListItemButton selected={url === path} style={{ paddingLeft: '25px' }}>
        <ListItemText primary={menuName} />
        {badgeCount > 0 && (
          <Badge
            badgeContent={badgeCount}
            color="error"
            max={99}
            sx={{
              ml: 'auto',
              mr: 1,
              '& .MuiBadge-badge': {
                position: 'static',
                transform: 'none',
              },
            }}
          />
        )}
      </ListItemButton>
    </ListItem>
  );
}
